import { render, staticRenderFns } from "./ChatNgWordsAlertCount.vue?vue&type=template&id=65d05076"
import script from "./ChatNgWordsAlertCount.vue?vue&type=script&lang=js"
export * from "./ChatNgWordsAlertCount.vue?vue&type=script&lang=js"
import style0 from "./ChatNgWordsAlertCount.vue?vue&type=style&index=0&id=65d05076&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports